import React, { Fragment, useEffect, useRef, useState } from "react";
import { ReactComponent as SearchIcon } from "../../assets/icons/search.svg";

type Props = {
  onChange?: any;
  state?: any;
};

const MobileSearch = (props: Props) => {
  const targetRef = useRef(null);
  const [isFocused, setIsFocused] = useState(false);
  //   const [inputValue, setInputValue] = useState("");
  const showSearchInput = isFocused;
  useEffect(() => {
    targetRef.current.value = "";
  }, [showSearchInput]);

  const handleExpandSearch = (boolean) => {
    setIsFocused(boolean);
    props.state(boolean);
  };

  const handleShrinkSearch = (boolean) => {
    setIsFocused(boolean);
    props.state(boolean);
  };

  return (
    <Fragment>
      <div
        className="mobile-search-container"
        style={showSearchInput ? { width: "100%" } : {}}
        onClick={() => handleExpandSearch(true)}
        onBlur={() => handleShrinkSearch(false)}
      >
        <div className="search-icon-container">
          <SearchIcon />
        </div>
        <input
          type="text"
          className={`search-input ${showSearchInput ? "active" : ""}`}
          onChange={props.onChange}
          ref={targetRef}
        />
      </div>
    </Fragment>
  );
};

export default MobileSearch;
